module.exports = __webpack_public_path__ + "img/san-jose-restaurant.37270e67.jpg";